import { PROXIMA_API_CACHE_TAGS, proximaApi } from '../proximaApi'
import { type AuthenticationCheck, type LoginPayload, type LoginResponse } from '../schema-dtos/AuthDomainDtos'
import { type ForgotPasswordPayload, type ResetPasswordPayload } from '../schema-dtos/AuthPayloadDtos'
const SUB_URL = '/users'

export const authenticationApi = proximaApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, Partial<LoginPayload>>({
      query: (body) => ({
        url: `${SUB_URL}/auth/login`,
        method: 'POST',
        body
      }),
      invalidatesTags: PROXIMA_API_CACHE_TAGS
    }),
    logout: builder.mutation<undefined, Partial<void>>({
      query: () => ({
        url: `${SUB_URL}/auth/logout`,
        method: 'POST'
      })
      // We don't invalidate here as this seems to cause a fetch but because we're now
      // unauthenticated, we get a 401 and cache that.
      // invalidatesTags: PROXIMA_API_CACHE_TAGS
    }),
    checkAuthenticated: builder.mutation<AuthenticationCheck, Partial<void>>({
      query: () => ({
        url: `${SUB_URL}/auth/check`,
        method: 'POST'
      })
    }),

    requestPasswordReset: builder.mutation<undefined, Partial<ForgotPasswordPayload>>({
      query: (body) => ({
        url: `${SUB_URL}/password/forgot`,
        method: 'POST',
        body
      })
    }),

    resetPassword: builder.mutation<undefined, Partial<ResetPasswordPayload>>({
      query: (body) => ({
        url: `${SUB_URL}/password/reset`,
        method: 'POST',
        body
      })
    })
  }),
  overrideExisting: false
})

export const useAuthLoginMutation = authenticationApi.endpoints.login.useMutation
export const useAuthLogoutMutation = authenticationApi.endpoints.logout.useMutation
export const useAuthCheckAuthenticated = authenticationApi.endpoints.checkAuthenticated.useMutation
export const useRequestPasswordResetMutation = authenticationApi.endpoints.requestPasswordReset.useMutation
export const useResetPasswordMutation = authenticationApi.endpoints.resetPassword.useMutation
